import { useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Contato } from '../types';

interface ContatoUpsertInput {
  empresa_id: string;
  id?: string;
  payload: Partial<Omit<Contato, 'id' | 'empresa_id'>>;
}

export function useContatoUpsert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: ContatoUpsertInput) => {
      return n8nFetch<Contato>('/contato-upsert', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['contatos', vars.empresa_id] });
    },
  });
}
